// extracted by mini-css-extract-plugin
export default {"action_menu_dropdown":"ListActionBtns_action_menu_dropdown__QXur5"};